import createIcon from '../../createIcon';

/**
 * @component @name TurnedIn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgM0g3QzUuOSAzIDUuMDEgMy45IDUuMDEgNUw1IDIxTDEyIDE4TDE5IDIxVjVDMTkgMy45IDE4LjEgMyAxNyAzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnedIn = createIcon('TurnedIn', [
  [
    'path',
    { d: 'M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z', key: '1gzjku' },
  ],
]);

export default TurnedIn;
